/* ===========================================
   Integration Page Sticky Nav (FacetWP) — with Filter Lock
   =========================================== */

( function () {
  const cfg = {
    stickyWrapperSelector: '.e-stn--general-posts-integrations .e-div--content-wrapper',
    navScrollContainerSelector: '.e-stn--general-posts-integrations .e-div--content-wrapper',
    listItemSelector: '.facetwp-radio',
    sectionSelector: '.integration-row',
    sectionTitleSelector: 'h3.integration-type-title',
    headerSelector: 'header',
    adminBarSelector: '#wpadminbar',
  
    largeScreenWidth: 992,
    defaultOffset: 60,
    marginTop: 12,
    marginBottom: 12,
    visibilityBuffer: 12,
    epsilon: 1,
    innerScrollDuration: 280,
    innerScrollEasing: ( t ) => 1 - ( 1 - t ) ** 3,
    edgeThreshold: 6,
  
    ioRootMargin: '-30% 0% -70%',
    ioThreshold: 0,
  
    queryParam: '_integration_category'
  };
  
  const $ = ( sel, root = document ) => root.querySelector( sel );
  const $$ = ( sel, root = document ) => Array.from( root.querySelectorAll( sel ) );
  const clamp = ( v, min, max ) => Math.min( max, Math.max( min, v ) );
  const prefersReducedMotion = () => window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
  const isDesktop = () => window.innerWidth >= cfg.largeScreenWidth;
  
  function headerHeights() {
    const header = $( cfg.headerSelector );
    const admin = $( cfg.adminBarSelector );
    return { header: header?.offsetHeight || 0, admin: admin?.offsetHeight || 0 };
  }
  
  class IntegrationStickyNav {
    constructor() {
      this.stickyWrapper = $( cfg.stickyWrapperSelector );
      this.navContainer = $( cfg.navScrollContainerSelector ) || this.stickyWrapper;
      this.header = $( cfg.headerSelector );
      if ( !this.stickyWrapper || !this.header ) return;
  
      this.items = $$( cfg.listItemSelector );
      this.sections = $$( cfg.sectionSelector );
  
      this.slugToTitle = new Map();
      this.sections.forEach( sec => {
        const title = $( cfg.sectionTitleSelector, sec );
        const id = title?.getAttribute( 'id' );
        if ( id ) this.slugToTitle.set( id, title );
      } );
      if ( !this.items.length || this.slugToTitle.size === 0 ) return;
  
      this.sectionRoot = this.detectSectionRoot();
  
      this._anim = null;
      this._lastAim = null;
      this.edgeLock = null; // 'top' | 'bottom' | null
      this.filterLockedSlug = null; // when set, only this slug stays highlighted
  
      this.onResize = this.onResize.bind( this );
      this.onScroll = this.onScroll.bind( this );
      this.onFacetClick = this.onFacetClick.bind( this );
      this.ioCallback = this.ioCallback.bind( this );
  
      this.attach();
      this.applyStickyStyles();
      this.bootstrapLockFromURL();
      this.bootstrapLockFromDOM();
      if ( !this.isFilterLocked() ) this.firstActive();
  
      this.onResize();
      this.onScroll();
      this.observeSections();
      this.scrollToFromURL();
    }
  
    /* ---------- locking ---------- */
    isFilterLocked() { return !!this.filterLockedSlug; }
    lockToSlug( slug ) {
      this.filterLockedSlug = slug || null;
      if ( this.filterLockedSlug ) this.setActiveBySlug( this.filterLockedSlug );
    }
    unlockFilter() {
      this.filterLockedSlug = null;
    }
  
    bootstrapLockFromURL() {
      const params = new URLSearchParams( window.location.search );
      const slug = params.get( cfg.queryParam );
      if ( slug && this.slugToTitle.has( slug ) ) {
        this.lockToSlug( slug );
      }
    }
    bootstrapLockFromDOM() {
      // Try to infer currently-selected FacetWP radio
      const selected = this.items.find( it =>
        it.classList.contains( 'checked' ) ||
          it.getAttribute( 'aria-checked' ) === 'true' ||
          it.classList.contains( 'active' ) ||
          it.querySelector( 'input[type="radio"]:checked' )
      );
      if ( selected?.dataset?.value ) {
        this.lockToSlug( selected.dataset.value );
      }
    }
  
    /* ---------- setup ---------- */
    detectSectionRoot() {
      let node = this.stickyWrapper;
      while ( node && node !== document.body ) {
        if ( $$( cfg.sectionSelector, node ).length === this.sections.length ) return node;
        node = node.parentElement;
      }
      node = this.stickyWrapper;
      while ( node && node !== document.body ) {
        if ( $$( cfg.sectionSelector, node ).length ) return node;
        node = node.parentElement;
      }
      return document.body;
    }
  
    attach() {
      window.addEventListener( 'resize', this.onResize );
      window.addEventListener( 'scroll', this.onScroll, { passive: true } );
  
      this.items.forEach( el => {
        el.addEventListener( 'click', this.onFacetClick );
        el.addEventListener( 'keyup', ( e ) => {
          if ( e.key === 'Enter' || e.key === ' ' ) this.onFacetClick( e );
        } );
      } );
  
      document.addEventListener( 'facetwp-loaded', () => {
        // Rebind radios and sections after FacetWP updates DOM
        this.items = $$( cfg.listItemSelector );
        this.items.forEach( el => {
          el.removeEventListener( 'click', this.onFacetClick );
          el.addEventListener( 'click', this.onFacetClick );
        } );
        this.sections = $$( cfg.sectionSelector );
        this.slugToTitle.clear();
        this.sections.forEach( sec => {
          const title = $( cfg.sectionTitleSelector, sec );
          const id = title?.getAttribute( 'id' );
          if ( id ) this.slugToTitle.set( id, title );
        } );
  
        // Update lock state from DOM (if facet changed)
        this.bootstrapLockFromDOM();
        // If still no lock, try URL; else keep existing lock
        if ( !this.isFilterLocked() ) this.bootstrapLockFromURL();
  
        this.disconnectObserver();
        this.observeSections();
  
        this.applyStickyStyles();
        if ( !this.isFilterLocked() ) this.firstActive();
        else this.setActiveBySlug( this.filterLockedSlug );
  
        this.onResize();
        this.onScroll();
      } );
    }
  
    firstActive() {
      this.setActiveByIndex( 0 );
    }
  
    disconnectObserver() {
      if ( this._observer ) this._observer.disconnect();
      this._observer = null;
    }
  
    observeSections() {
      this.disconnectObserver();
      const options = { root: null, rootMargin: cfg.ioRootMargin, threshold: cfg.ioThreshold };
      this._observer = new IntersectionObserver( this.ioCallback, options );
      this.sections.forEach( sec => this._observer.observe( sec ) );
    }
  
    ioCallback( entries ) {
      if ( this.isFilterLocked() ) return; // don't override locked highlight
      entries.forEach( entry => {
        if ( !entry.isIntersecting ) return;
        const title = $( cfg.sectionTitleSelector, entry.target );
        const visibleId = title?.getAttribute( 'id' );
        if ( !visibleId ) return;
        this.setActiveBySlug( visibleId );
        this.ensureActiveVisible( { smooth: true } );
      } );
    }
  
    applyStickyStyles() {
      const { header, admin } = headerHeights();
      const stickyTop = header + admin + cfg.defaultOffset;
      const viewportH = window.innerHeight;
      const wrapperH = this.stickyWrapper.getBoundingClientRect().height;
  
      if ( wrapperH > ( viewportH - stickyTop ) ) {
        this.stickyWrapper.classList.add( 'remove-sticky' );
      } else {
        this.stickyWrapper.classList.remove( 'remove-sticky' );
      }
  
      if ( isDesktop() ) {
        const maxH = Math.max( 120, viewportH - ( header + admin + ( cfg.defaultOffset * 2 ) ) );
        Object.assign( this.stickyWrapper.style, {
          position: 'sticky',
          top: `${stickyTop}px`,
          transition: 'top 0.2s ease'
        } );
        Object.assign( this.navContainer.style, {
          overflowY: 'auto',
          maxHeight: `${Math.round( maxH )}px`
        } );
      } else {
        Object.assign( this.stickyWrapper.style, { position: '', top: '', transition: '' } );
        Object.assign( this.navContainer.style, { overflowY: '', maxHeight: '' } );
      }
    }
  
    cancelAnim() {
      if ( this._anim?.raf ) cancelAnimationFrame( this._anim.raf );
      this._anim = null;
    }
    smoothInnerTo( target ) {
      const c = this.navContainer;
      const max = Math.max( 0, c.scrollHeight - c.clientHeight );
      const to = clamp( Math.round( target ), 0, max );
      const from = c.scrollTop;
      const delta = to - from;
  
      if ( Math.abs( delta ) < cfg.epsilon ) {
        c.scrollTop = to;
        this._lastAim = to;
        return;
      }
      if ( this._lastAim != null && Math.abs( to - this._lastAim ) < cfg.epsilon ) return;
  
      if ( prefersReducedMotion() || cfg.innerScrollDuration <= 0 ) {
        c.scrollTop = to;
        this._lastAim = to;
        return;
      }
  
      this.cancelAnim();
      const start = performance.now();
      const dur = cfg.innerScrollDuration;
      const ease = cfg.innerScrollEasing;
      this._lastAim = to;
  
      const step = ( now ) => {
        const t = Math.min( 1, ( now - start ) / dur );
        c.scrollTop = from + delta * ease( t );
        if ( t < 1 ) {
          this._anim = { raf: requestAnimationFrame( step ) };
        } else {
          this._anim = null;
        }
      };
      this._anim = { raf: requestAnimationFrame( step ) };
    }
  
    ensureActiveVisible( { smooth = true } = {} ) {
      if ( !isDesktop() || this.edgeLock ) return;
      const active = this.items.find( it => it.classList.contains( 'active' ) );
      if ( !active ) return;
  
      const c = this.navContainer;
      const cRect = c.getBoundingClientRect();
      const aRect = active.getBoundingClientRect();
      const cur = c.scrollTop;
  
      const safeTop = cur + cfg.marginTop + cfg.visibilityBuffer;
      const safeBottom = cur + c.clientHeight - cfg.marginBottom - cfg.visibilityBuffer;
  
      const aTop = ( aRect.top - cRect.top ) + cur;
      const aBot = ( aRect.bottom - cRect.top ) + cur;
  
      let target = null;
      if ( aTop < safeTop ) {
        target = aTop - ( cfg.marginTop + cfg.visibilityBuffer );
      } else if ( aBot > safeBottom ) {
        target = aBot - ( c.clientHeight - cfg.marginBottom - cfg.visibilityBuffer );
      }
  
      if ( target == null || Math.abs( target - cur ) < cfg.epsilon ) return;
  
      if ( smooth ) {
        this.smoothInnerTo( target );
      } else {
        c.scrollTop = Math.round( target );
        this._lastAim = target;
      }
    }
  
    // Section edges (for snapping inner list without changing active when locked)
    sectionTop() { const r = this.sectionRoot.getBoundingClientRect(); return r.top + window.scrollY; }
    // eslint-disable-next-line max-len
    sectionBottom() { const r = this.sectionRoot.getBoundingClientRect(); return r.top + window.scrollY + this.sectionRoot.offsetHeight; }
    isNearTop() { return window.scrollY <= ( this.sectionTop() + cfg.edgeThreshold ); }
    // eslint-disable-next-line max-len
    isNearBottom() { const vb = window.scrollY + window.innerHeight; return vb >= ( this.sectionBottom() - cfg.edgeThreshold ); }
  
    scrollNavToStart( smooth = true, mutateActive = true ) {
      if ( !isDesktop() ) return;
      this.edgeLock = 'top';
      if ( mutateActive && !this.isFilterLocked() ) this.setActiveByIndex( 0 );
      if ( this.navContainer.scrollTop <= cfg.epsilon ) return;
  
      if ( smooth ) {
        this.smoothInnerTo( 0 );
      } else {
        this.navContainer.scrollTop = 0;
        this._lastAim = 0;
      }
    }
    scrollNavToEnd( smooth = true, mutateActive = true ) {
      if ( !isDesktop() ) return;
      const max = Math.max( 0, this.navContainer.scrollHeight - this.navContainer.clientHeight );
      if ( Math.abs( max - this.navContainer.scrollTop ) < cfg.epsilon ) return;
      this.edgeLock = 'bottom';
      if ( mutateActive && !this.isFilterLocked() ) this.setActiveByIndex( this.items.length - 1 );
  
      if ( smooth ) {
        this.smoothInnerTo( max );
      } else {
        this.navContainer.scrollTop = max;
        this._lastAim = max;
      }
    }
  
    setActiveByIndex( i ) { this.items.forEach( ( el, idx ) => el.classList.toggle( 'active', idx === i ) ); }
    setActiveBySlug( slug ) { this.items.forEach( el => el.classList.toggle( 'active', el.dataset.value === slug ) ); }
  
    /* -------- events -------- */
    onResize() {
      this.applyStickyStyles();
  
      if ( this.isNearTop() ) this.scrollNavToStart( false, /*mutateActive*/ !this.isFilterLocked() );
      else if ( this.isNearBottom() ) this.scrollNavToEnd( false, /*mutateActive*/ !this.isFilterLocked() );
      else this.edgeLock = null;
  
      this.ensureActiveVisible( { smooth: false } );
    }
  
    onScroll() {
      // Edge priority: snap inner list; DO NOT change active if locked
      if ( this.isNearTop() ) {
        this.scrollNavToStart( true, /*mutateActive*/ !this.isFilterLocked() );
        return;
      }
      if ( this.isNearBottom() ) {
        this.scrollNavToEnd( true, /*mutateActive*/ !this.isFilterLocked() );
        return;
      }
      this.edgeLock = null;
  
      // If locked by filter: keep only that item highlighted, ignore IO/scroll-based changes
      if ( this.isFilterLocked() ) {
        this.setActiveBySlug( this.filterLockedSlug );
        this.ensureActiveVisible( { smooth: true } );
        return;
      }
  
      // Not locked → IO manages active; just keep visible
      this.ensureActiveVisible( { smooth: true } );
    }
  
    onFacetClick( e ) {
      const slug = e.currentTarget?.dataset?.value;
      const title = slug ? this.slugToTitle.get( slug ) : null;
      if ( !slug || !title ) return;
  
      // Lock to the chosen filter and highlight only it
      this.lockToSlug( slug );
      this.setActiveBySlug( slug );
  
      const { header, admin } = headerHeights();
      const y = title.getBoundingClientRect().top + window.scrollY - ( header + admin );
      window.scrollTo( { top: y, behavior: 'smooth' } );
  
      setTimeout( () => this.ensureActiveVisible( { smooth: true } ), 360 );
    }
  
    scrollToFromURL() {
      const params = new URLSearchParams( window.location.search );
      const slug = params.get( cfg.queryParam );
      if ( !slug ) return;
      const title = this.slugToTitle.get( slug );
      if ( !title ) return;
  
      this.lockToSlug( slug );
      this.setActiveBySlug( slug );
  
      const { header, admin } = headerHeights();
      const y = title.getBoundingClientRect().top + window.scrollY - ( header + admin );
      window.scrollTo( { top: y, behavior: 'smooth' } );
  
      setTimeout( () => this.ensureActiveVisible( { smooth: true } ), 360 );
    }
  }
  
  /* -------- boot -------- */
  window.addEventListener( 'load', () => {
    const controller = new IntegrationStickyNav();
    if ( !controller ) return;
    window.addEventListener( 'resize', () => controller.applyStickyStyles() );
  } );
} )();
  